import { render, staticRenderFns } from "./PointsCom.vue?vue&type=template&id=072a6d6a&scoped=true"
import script from "./PointsCom.vue?vue&type=script&lang=js"
export * from "./PointsCom.vue?vue&type=script&lang=js"
import style0 from "./PointsCom.vue?vue&type=style&index=0&id=072a6d6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a6d6a",
  null
  
)

export default component.exports